// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"0fdd18a4","147":"cc7ab7e5","453":"430a030c","681":"56be21b8","885":"f2b1c255","916":"9f0ae09e"}[chunkId] + ".chunk.js";
};